import { CmpApi } from '@iabtechlabtcf/cmpapi'

import {
  CMP_ID,
  CMP_VERSION,
} from 'constants/cmp'

import {
  getACString,
  getTCFSettings,
} from 'utils/tcfStore'

import { USES_SERVICE_SPECIFIC_SCOPE } from './constants'


export default function makeCmpApi() {
  return new CmpApi(CMP_ID, CMP_VERSION, USES_SERVICE_SPECIFIC_SCOPE, {
    getTCData(next, tcData, success) {
      // When launching the IAB CMP Validator, `tcData` comes back as null.
      //
      // When `removeEventListener` is called, `tcData` is actually a
      // boolean (the success status), so we obviously can't set data
      // members on it. It's crucial that `removeEventListener`
      // returns a boolean, otherwise the IAB TCF validator will fail
      // the "Did all CMP API required commands return a correct
      // response?"  technical compliance check.
      if ( tcData !== null && typeof tcData === 'object' ) {
        const tcfSettings = getTCFSettings()
        tcData.enableAdvertiserConsentMode = Boolean(tcfSettings?.enable_advertiser_consent_mode)

        tcData.addtlConsent = getACString()
      }

      next(tcData, success)
    },
  })
}
